(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9572],{

/***/ 75355:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web/city/[cityName]",
      function () {
        return __webpack_require__(24273);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$$": function() { return /* binding */ getPlaceDescriptionLabel; },
/* harmony export */   "Cb": function() { return /* binding */ getPlaceCityLabel; },
/* harmony export */   "zt": function() { return /* binding */ getPlaceStateLabel; }
/* harmony export */ });
/* unused harmony export getCityFromAddress */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87394);

function getCityFromAddress(address) {
    if (!(address === null || address === void 0 ? void 0 : address.trim())) {
        return "";
    }
    var parts = address.split(",").map(function(part) {
        return part.trim();
    }).filter(Boolean);
    if (parts.length === 0) {
        return "";
    }
    if (parts.length === 1) {
        return parts[0];
    }
    // Indian formatted addresses usually end with: ..., City, State PIN
    return parts[parts.length - 2] || parts[0];
}
function getPlaceCityState(place) {
    var ref;
    if (!place) {
        return {
            city: "",
            state: ""
        };
    }
    if ((ref = place.city) === null || ref === void 0 ? void 0 : ref.trim()) {
        var ref1;
        return {
            city: place.city.trim(),
            state: ((ref1 = place.state) === null || ref1 === void 0 ? void 0 : ref1.trim()) || ""
        };
    }
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((place.description || "").split(",").map(function(part) {
        return part.trim();
    }).filter(Boolean), 2), tmp = ref2[0], city = tmp === void 0 ? "" : tmp, tmp1 = ref2[1], state = tmp1 === void 0 ? "" : tmp1;
    return {
        city: city,
        state: state
    };
}
/** Short city label for route chips and summaries. */ function getPlaceCityLabel(place) {
    var ref, ref1, ref2, ref3;
    if (!place) {
        return "";
    }
    if ((ref = place.city) === null || ref === void 0 ? void 0 : ref.trim()) {
        return place.city.trim();
    }
    if ((ref1 = place.description) === null || ref1 === void 0 ? void 0 : ref1.trim()) {
        var cityFromDescription = getCityFromAddress(place.description);
        if (cityFromDescription) {
            return cityFromDescription;
        }
    }
    return ((ref2 = place.locality) === null || ref2 === void 0 ? void 0 : ref2.trim()) || ((ref3 = place.sub_locality) === null || ref3 === void 0 ? void 0 : ref3.trim()) || "";
}
/** State label from a place search result (city/state fields or parsed description). */ function getPlaceStateLabel(place) {
    return getPlaceCityState(place).state;
}
/** Full description for location search dropdown rows. */ function getPlaceDescriptionLabel(place) {
    var ref;
    if (!place) {
        return "";
    }
    if ((ref = place.description) === null || ref === void 0 ? void 0 : ref.trim()) {
        return place.description.trim();
    }
    var ref1 = getPlaceCityState(place), city = ref1.city, state = ref1.state;
    if (city && state) {
        return "".concat(city, ", ").concat(state);
    }
    return city || state;
}


/***/ }),

/***/ 14199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FY": function() { return /* binding */ getQuoteFormPickupToDropFocusDelayMs; },
/* harmony export */   "XQ": function() { return /* binding */ getQuoteFormLocationFieldConfig; },
/* harmony export */   "gs": function() { return /* binding */ getCompactSheetMountFocusDelayMs; },
/* harmony export */   "iZ": function() { return /* binding */ shouldDeferCompactSheetAutoFocusToUserTap; },
/* harmony export */   "mJ": function() { return /* binding */ createCompactSheetInputFocusHandler; },
/* harmony export */   "zq": function() { return /* reexport safe */ _vahak_core_ui_dist_methods_keyboardViewport__WEBPACK_IMPORTED_MODULE_0__.Ck; }
/* harmony export */ });
/* unused harmony export COMPACT_SHEET */
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42838);
/* harmony import */ var _vahak_core_ui_dist_methods_keyboardViewport__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69849);
/* harmony import */ var _vahak_core_ui_dist_methods_browser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82238);



/** Shared tuning for homepage v2 compact bottom-sheet flows (posting, bidding, auth). */ var COMPACT_SHEET = {
    MOUNT_FOCUS_DELAY_MS: 350,
    PICKUP_TO_DROP_FOCUS_DELAY_MS: 100,
    MENU_MAX_HEIGHT: 200,
    DESKTOP_MENU_MAX_HEIGHT: 300,
    /** Extra clearance above the field gap so auth inputs clear the sticky CTA. */ AUTH_STICKY_FOOTER_EXTRA_PX: 24
};

function getCompactSheetClearance(preset) {
    if (preset === "auth") {
        return (0,_vahak_core_ui_dist_methods_keyboardViewport__WEBPACK_IMPORTED_MODULE_0__/* .getKeyboardViewportClearance */ .e5)(COMPACT_SHEET.AUTH_STICKY_FOOTER_EXTRA_PX);
    }
    return undefined;
}
/**
 * onFocus / focusin handler for compact-sheet inputs.
 * `keepInKeyboardView` runs after the keyboard settles and no-ops when the field already clears it.
 */ function createCompactSheetInputFocusHandler() {
    var preset = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "field";
    return function(event) {
        if (!(0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(event.target, Element)) {
            return;
        }
        (0,_vahak_core_ui_dist_methods_keyboardViewport__WEBPACK_IMPORTED_MODULE_0__/* .keepInKeyboardView */ .uk)(event.target, {
            clearance: getCompactSheetClearance(preset)
        });
    };
}
function mobileQuoteFieldConfig(portalMenu) {
    var keyboardAware = (0,_vahak_core_ui_dist_methods_keyboardViewport__WEBPACK_IMPORTED_MODULE_0__/* .needsKeyboardViewportCompensation */ .hP)();
    return {
        portalMenu: portalMenu,
        keyboardAware: keyboardAware,
        menuPlacement: "bottom",
        // Android native scroll; iOS uses JS scroll instead.
        menuShouldScrollIntoView: !keyboardAware,
        maxMenuHeight: COMPACT_SHEET.MENU_MAX_HEIGHT
    };
}
function getQuoteFormLocationFieldConfig(options) {
    var inSheet = options.inSheet, role = options.role, _isMobile = options.isMobile, isMobile = _isMobile === void 0 ? (0,_vahak_core_ui_dist_methods_browser__WEBPACK_IMPORTED_MODULE_2__/* .isMobileViewport */ .UM)() : _isMobile;
    if (!inSheet && !isMobile) {
        return {
            portalMenu: false,
            keyboardAware: false,
            menuPlacement: "bottom",
            menuShouldScrollIntoView: true,
            maxMenuHeight: COMPACT_SHEET.DESKTOP_MENU_MAX_HEIGHT
        };
    }
    // Drop in sheet: non-portaled menu stays anchored while the sheet scrolls (iOS).
    if (inSheet) {
        if (!isMobile) {
            return {
                portalMenu: true,
                keyboardAware: false,
                menuPlacement: "bottom",
                menuShouldScrollIntoView: true,
                maxMenuHeight: COMPACT_SHEET.DESKTOP_MENU_MAX_HEIGHT
            };
        }
        // Drop in mobile sheet: non-portaled menu stays anchored while the sheet scrolls (iOS).
        return mobileQuoteFieldConfig(role !== "drop");
    }
    return mobileQuoteFieldConfig(true);
}
function getCompactSheetMountFocusDelayMs() {
    return COMPACT_SHEET.MOUNT_FOCUS_DELAY_MS;
}
function getQuoteFormPickupToDropFocusDelayMs() {
    return COMPACT_SHEET.PICKUP_TO_DROP_FOCUS_DELAY_MS;
}
/**
 * Programmatic focus on sheet mount breaks the iOS keyboard (deep links).
 * Android can autofocus — leave that path open.
 */ function shouldDeferCompactSheetAutoFocusToUserTap() {
    return (0,_vahak_core_ui_dist_methods_keyboardViewport__WEBPACK_IMPORTED_MODULE_0__/* .needsKeyboardViewportCompensation */ .hP)();
}


/***/ }),

/***/ 94280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XT": function() { return /* binding */ getMarketplaceLoadFaqList; },
/* harmony export */   "Xq": function() { return /* binding */ getMarketplaceInCityTextForSeoContent; },
/* harmony export */   "l$": function() { return /* binding */ getLorryTypeFromParam; },
/* harmony export */   "nH": function() { return /* binding */ parseMarketplaceLocationFromParamSegment; },
/* harmony export */   "sP": function() { return /* binding */ resolveMarketplaceLoadSeoContext; }
/* harmony export */ });
/* unused harmony exports botTest, formatMarketplaceLocationSlug, formatMarketplaceLocationLabel, getMarketplaceInCityTextFromSegment, getMarketplaceLegacyCityMeta */
/* harmony import */ var _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94204);
/* harmony import */ var _marketplace_content_content__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79733);


function getLorryTypeFromParam(lorryParam) {
    var req = Array.isArray(lorryParam) ? lorryParam : [
        lorryParam
    ];
    return (0,_vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_0__/* .getAllowedVehicleList */ .UE5)("lorry").filter(function(lorryType) {
        return req === null || req === void 0 ? void 0 : req.includes(lorryType.label.toLowerCase());
    });
}
function botTest(userAgent) {
    return /bot|crawler|spider|googlebot|bingbot|msnbot|yandexbot|baiduspider|slurp|duckduckbot/i.test(userAgent);
}
/** Mirrors SSR parsing in `pages/marketplace/[...params].tsx`. */ function parseMarketplaceLocationFromParamSegment(segment) {
    var ref, ref1;
    if (!segment) {
        return {
            src: "",
            dest: ""
        };
    }
    var locationParts = segment.split("to-");
    var ref2, ref3;
    return {
        src: (ref2 = (ref = locationParts[0]) === null || ref === void 0 ? void 0 : ref.replace(/-/g, " ")) !== null && ref2 !== void 0 ? ref2 : "",
        dest: locationParts.length === 2 ? (ref3 = (ref1 = locationParts[1]) === null || ref1 === void 0 ? void 0 : ref1.replace(/-/g, " ")) !== null && ref3 !== void 0 ? ref3 : "" : ""
    };
}
/** Format a marketplace URL slug (e.g. bengaluru-karnataka-india) for display in meta copy. */ function formatMarketplaceLocationSlug(slug) {
    return slug.replace(/-india$/i, "").replace(/-/g, " ").replace(/\b\w/g, function(char) {
        return char.toUpperCase();
    });
}
/** Format SSR-parsed location text (e.g. "bengaluru karnataka india") for display. */ function formatMarketplaceLocationLabel(label) {
    return label.replace(/\s+india\s*$/i, "").replace(/\b\w/g, function(char) {
        return char.toUpperCase();
    }).trim();
}
/** Legacy-compatible "in Bengaluru Karnataka" text for on-page SEO content lookup. */ function getMarketplaceInCityTextFromSegment(locationSegment) {
    if (!locationSegment) {
        return "";
    }
    var cityDisplayName = formatMarketplaceLocationSlug(locationSegment);
    return cityDisplayName ? "in ".concat(cityDisplayName) : "";
}
/** Shared in-city phrase for FAQ blocks, H1 copy, and legacy marketplace pages. */ function getMarketplaceInCityTextForSeoContent(param) {
    var locationSegment = param.locationSegment, _urlSrc = param.urlSrc, urlSrc = _urlSrc === void 0 ? "" : _urlSrc, _urlDest = param.urlDest, urlDest = _urlDest === void 0 ? "" : _urlDest;
    var seoContext = resolveMarketplaceLoadSeoContext({
        locationSegment: locationSegment,
        urlSrc: urlSrc,
        urlDest: urlDest
    });
    if (seoContext.kind === "city" || seoContext.kind === "destination") {
        return seoContext.inCityText;
    }
    if (locationSegment) {
        return getMarketplaceInCityTextFromSegment(locationSegment);
    }
    return "";
}
function resolveMarketplaceLoadSeoContext(param) {
    var locationSegment = param.locationSegment, _urlSrc = param.urlSrc, urlSrc = _urlSrc === void 0 ? "" : _urlSrc, _urlDest = param.urlDest, urlDest = _urlDest === void 0 ? "" : _urlDest;
    var parsed = parseMarketplaceLocationFromParamSegment(locationSegment);
    var src = (urlSrc || parsed.src).trim();
    var dest = (urlDest || parsed.dest).trim();
    if (src && dest) {
        var fromCity = formatMarketplaceLocationLabel(src);
        var toCity = formatMarketplaceLocationLabel(dest);
        return {
            kind: "route",
            fromCity: fromCity,
            toCity: toCity,
            routeLabel: "".concat(fromCity, " to ").concat(toCity)
        };
    }
    if (dest) {
        var cityDisplayName = formatMarketplaceLocationLabel(dest);
        return {
            kind: "destination",
            cityDisplayName: cityDisplayName,
            inCityText: "in ".concat(cityDisplayName)
        };
    }
    if (src) {
        var cityDisplayName1 = formatMarketplaceLocationLabel(src);
        return {
            kind: "city",
            cityDisplayName: cityDisplayName1,
            inCityText: "in ".concat(cityDisplayName1)
        };
    }
    if (locationSegment === null || locationSegment === void 0 ? void 0 : locationSegment.startsWith("to-")) {
        var cityDisplayName2 = formatMarketplaceLocationSlug(locationSegment.replace(/^to-/, ""));
        return {
            kind: "destination",
            cityDisplayName: cityDisplayName2,
            inCityText: "in ".concat(cityDisplayName2)
        };
    }
    if (locationSegment) {
        var cityDisplayName3 = formatMarketplaceLocationSlug(locationSegment);
        return {
            kind: "city",
            cityDisplayName: cityDisplayName3,
            inCityText: "in ".concat(cityDisplayName3)
        };
    }
    return {
        kind: "default"
    };
}
/** City-aware FAQ for marketplace load pages — falls back to generic list when no location in URL. */ function getMarketplaceLoadFaqList(param) {
    var locationSegment = param.locationSegment, _urlSrc = param.urlSrc, urlSrc = _urlSrc === void 0 ? "" : _urlSrc, _urlDest = param.urlDest, urlDest = _urlDest === void 0 ? "" : _urlDest, genericFaqList = param.genericFaqList;
    var inCityText = getMarketplaceInCityTextForSeoContent({
        locationSegment: locationSegment,
        urlSrc: urlSrc,
        urlDest: urlDest
    });
    if (inCityText) {
        return (0,_marketplace_content_content__WEBPACK_IMPORTED_MODULE_1__/* .getMktContentByCity */ .o)(inCityText, true).faqList;
    }
    return genericFaqList;
}
/** English meta copy for legacy marketplace v2 (load + lorry routes). */ function getMarketplaceLegacyCityMeta(param) {
    var locationSegment = param.locationSegment, _urlSrc = param.urlSrc, urlSrc = _urlSrc === void 0 ? "" : _urlSrc, _urlDest = param.urlDest, urlDest = _urlDest === void 0 ? "" : _urlDest, isLoadMarket = param.isLoadMarket, _fallbackCityText = param.fallbackCityText, fallbackCityText = _fallbackCityText === void 0 ? "" : _fallbackCityText;
    var seoContext = resolveMarketplaceLoadSeoContext({
        locationSegment: locationSegment,
        urlSrc: urlSrc,
        urlDest: urlDest
    });
    var cityDisplayName = fallbackCityText;
    if (seoContext.kind === "city" || seoContext.kind === "destination") {
        cityDisplayName = seoContext.cityDisplayName;
    } else if (seoContext.kind === "route") {
        cityDisplayName = seoContext.routeLabel;
    } else if (locationSegment) {
        cityDisplayName = formatMarketplaceLocationSlug(locationSegment);
    }
    var cityTextWithoutIndia = cityDisplayName;
    var inCityTextWithoutIndia = cityDisplayName ? "in ".concat(cityDisplayName) : "";
    var inCityText = inCityTextWithoutIndia;
    var metaTitle = isLoadMarket ? cityDisplayName ? "Find Truck Load Online in ".concat(cityDisplayName, " - India's Top Transport Marketplace") : "Find Instant Truck Load Online - India's Top Transport Marketplace" : cityDisplayName ? "Find Online Truck Booking in ".concat(cityDisplayName, " - India's Top Marketplace") : "Book Your Truck Online : India's Top Lorry Booking Marketplace";
    var metaDescription = isLoadMarket ? "Book truck loads online in ".concat(cityDisplayName, " with ease. Our online platform offers GST and Aadhaar Verified Transport Services, truck owners and agents at your convenience. Book now.") : "Find instant truck, load, and lorry bookings online in ".concat(cityDisplayName, " on India's largest transport marketplace. Streamline your logistics with ease. Register & Bid Now!");
    var metaKeywords = isLoadMarket ? "truck load booking near me, online load booking ".concat(inCityText, ", load booking ").concat(cityDisplayName, ", find truck loads ").concat(inCityText, ", find load for my truck ").concat(inCityText, ", how to find load for truck, truck attachment ").concat(inCityText) : "truck booking ".concat(cityDisplayName, ", online truck booking ").concat(inCityText, ", truck booking app ").concat(cityDisplayName, ", mini truck transport ").concat(inCityText, ", online mini truck booking ").concat(cityDisplayName);
    return {
        city: cityDisplayName,
        CITY_TEXT_WITHOUT_INDIA: cityTextWithoutIndia,
        IN_CITY_TEXT: inCityText,
        IN_CITY_TEXT_WITHOUT_INDIA: inCityTextWithoutIndia,
        META_TITLE: metaTitle,
        META_DESCRIPTION: metaDescription,
        META_KEYWORDS: metaKeywords
    };
}


/***/ }),

/***/ 79733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ getMktContentByCity; }
/* harmony export */ });
var getMktContentByCity = function(IN_CITY_TEXT, isLoad) {
    var loadLorryText = isLoad ? "load" : "lorry";
    var titleH1Desc = "Vahak is India’s largest and most trusted online transport services company ".concat(IN_CITY_TEXT, ". We at Vahak are committed to improving the Indian transportation services industry through a technology-driven approach. Through our platform, we are helping reduce the current demand-supply gap in the transport industry by providing instant online ").concat(loadLorryText, " ").concat(IN_CITY_TEXT, ".\n    Vahak hosts India’s largest ").concat(loadLorryText, " marketplace, allowing users to book transport services instantly without paying commission charges. Through the Vahak Transport Marketplace, users can bid & book loads or lorries from across India.");
    var content = [
        {
            title: "Why Choose Vahak Marketplace Portal ".concat(IN_CITY_TEXT),
            description: [
                {
                    id: 0,
                    content: "With Vahak, explore the best platform for loads and vehicles ".concat(IN_CITY_TEXT, ". Embark on a revolutionary transportation experience with Vahak in now, a marketplace tailored to fulfil all of your logistical requirements.")
                }
            ],
            contentList: [
                {
                    id: 0,
                    title: "Registered Transporters",
                    description: "With Vahak, you can feel secure knowing that each transporter has their Aadhar and GST validated. Your safety and security are our top priorities, and Vahak ensures you work with reliable and respectable experts."
                },
                {
                    id: 1,
                    title: "Shippers' Profiles",
                    description: "Get access to extensive shipper profiles, enabling you to make knowledgeable selections. Such profiles offer crucial information that will assist you in selecting the ideal partners for your logistical needs."
                },
                {
                    id: 2,
                    title: "Reliable Transportation",
                    description: "Make use of Vahak's trustworthy and efficient transport services to maximise your logistics. Your items will be transported quickly and safely to their destination thanks to the efficiency of the platform."
                },
                {
                    id: 3,
                    title: "Extensive Network",
                    description: "Take advantage of our vast network of shippers and carriers throughout. Vahak gives you access to a large community, thereby improving the likelihood of discovering the ideal travel options."
                },
                {
                    id: 4,
                    title: "Cost-effective Pricing",
                    description: "Take advantage of the affordable pricing strategy, which is intended to give you the most value for your money. Vahak enables you to control your transportation expenses efficiently and transparently."
                }
            ]
        }
    ];
    var faqList = [
        {
            question: "How do I use the Vahak Marketplace to find ".concat(loadLorryText, " ").concat(IN_CITY_TEXT, "?"),
            answer: "While searching over the Vahak portal, opt for the find ".concat(loadLorryText, " option ").concat(IN_CITY_TEXT, ". Find ").concat(loadLorryText, " as per your choice.")
        },
        {
            question: "How can I filter ".concat(loadLorryText, " listings based on my preferences?"),
            answer: "Utilise Vahak's comprehensive search parameters to refine your ".concat(loadLorryText, " of listings. To swiftly identify the best choices, you may select by cargo type, weight, destination, and other factors.")
        },
        {
            question: "How do I submit a bid for a load on the Vahak Marketplace?",
            answer: 'Select the load you’re interested in, click on "Submit Bid," and enter your bid amount along with any relevant details. Confirm your bid to send it to the load provider.'
        },
        {
            question: "Can I track the status of my bid submissions?",
            answer: "To monitor the status of my bid submissions, you can simply search for the 'My Bids' section. Here, you will know if your bid was approved or likely to be approved."
        },
        {
            question: "Is there a messaging system available to communicate with load providers?",
            answer: "Vahak offers a built-in messaging system that allows you to communicate directly with load providers."
        },
        {
            question: "What payment methods are accepted for load transactions?",
            answer: "Vahak supports transactions through digital wallets, debit cards, UPI, and bank transfers."
        }
    ];
    return {
        titleH1Desc: titleH1Desc,
        content: content,
        faqList: faqList
    };
};


/***/ }),

/***/ 24273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Cities; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _components_layout_plain_layout_PlainLayout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23441);
/* harmony import */ var _components_city_CityLandingPage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61887);




var __N_SSG = true;
function Cities(param) {
    var cityConfig = param.cityConfig;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_city_CityLandingPage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        cityConfig: cityConfig
    });
};
Cities.getLayout = function(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_layout_plain_layout_PlainLayout__WEBPACK_IMPORTED_MODULE_2__/* .PlainLayout */ .o, {
        page: page
    });
};


/***/ }),

/***/ 42838:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5502,8416,8116,1887,9774,2888,179], function() { return __webpack_exec__(75355); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);